import { PhotoType } from "./photoDataPhotoType";

export class PlannedServicePhotoData {
  public blobServiceFileName: string;
  public type: PhotoType
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/plannedServicePhotoData.ts